import { prepaidCards } from '@huggg/back-bar';
import initialStateLoader from '../initialState';

const SUBMIT_FORM = 'huggg/prepaid-cards/SUBMIT_FORM';

const GENERATE_OTP = 'huggg/prepaid-cards/GENERATE_OTP';
const GENERATE_OTP_SUCCESS = 'huggg/prepaid-cards/GENERATE_OTP_SUCCESS';
const GENERATE_OTP_ERROR = 'huggg/prepaid-cards/GENERATE_OTP_ERROR';

const FETCH_CARD_DATA = 'huggg/prepaid-cards/FETCH_CARD_DATA';
const FETCH_CARD_DATA_SUCCESS = 'huggg/prepaid-cards/FETCH_CARD_DATA_SUCCESS';
const FETCH_CARD_DATA_ERROR = 'huggg/prepaid-cards/FETCH_CARD_DATA_ERROR';

const FETCH_SENSITIVE_CARD_DATA =
  'huggg/prepaid-cards/FETCH_SENSITIVE_CARD_DATA';
const FETCH_SENSITIVE_CARD_DATA_SUCCESS =
  'huggg/prepaid-cards/FETCH_SENSITIVE_CARD_DATA_SUCCESS';
const FETCH_SENSITIVE_CARD_DATA_ERROR =
  'huggg/prepaid-cards/FETCH_SENSITIVE_CARD_DATA_ERROR';

const REPORT_MISUSE = 'huggg/prepaid-cards/REPORT_MISUSE';
const REPORT_MISUSE_SUCCESS = 'huggg/prepaid-cards/REPORT_MISUSE_SUCCESS';
const REPORT_MISUSE_ERROR = 'huggg/prepaid-cards/REPORT_MISUSE_ERROR';

const OTP_TIMER_START = 'huggg/prepaid-cards/OTP_TIMER_START';
const OTP_TIMER_STOP = 'huggg/prepaid-cards/OTP_TIMER_STOP';
const OTP_TIMER_TICK = 'huggg/prepaid-cards/OTP_TIMER_TICK';

const OTP_DELAY_SEC = 30;
const { prepaidCard: initialState } = initialStateLoader();

/* Reducer - Default Export
========================================================================== */
const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case SUBMIT_FORM:
      return { ...state, formData: payload.formData };

    case OTP_TIMER_START:
      return {
        ...state,
        otpDelay: OTP_DELAY_SEC,
      };

    case OTP_TIMER_STOP:
      return {
        ...state,
        otpDelay: 0,
      };

    case OTP_TIMER_TICK:
      return {
        ...state,
        otpDelay: Math.max(state.otpDelay - 1, 0),
      };

    case FETCH_CARD_DATA:
      return {
        ...state,
        fetchCardDataError: null,
        isFetchingCardData: true,
      };

    case FETCH_CARD_DATA_SUCCESS:
      return {
        ...state,
        fetchCardDataError: null,
        isFetchingCardData: false,
        cardData: payload.cardData,
      };

    case FETCH_CARD_DATA_ERROR:
      return {
        ...state,
        fetchCardDataError: payload.error,
        isFetchingCardData: false,
      };

    case FETCH_SENSITIVE_CARD_DATA:
      return {
        ...state,
        fetchSensitiveCardDataError: null,
        isFetchingSensitiveCardData: true,
      };

    case FETCH_SENSITIVE_CARD_DATA_SUCCESS:
      return {
        ...state,
        fetchSensitiveCardDataError: null,
        isFetchingSensitiveCardData: false,
        sensitiveCardData: payload.sensitiveCardData,
      };

    case FETCH_SENSITIVE_CARD_DATA_ERROR:
      return {
        ...state,
        fetchSensitiveCardDataError: payload.error,
        isFetchingSensitiveCardData: false,
      };

    case REPORT_MISUSE:
      return {
        ...state,
        reportMisuseError: null,
        isReportingMisuse: true,
      };

    case REPORT_MISUSE_SUCCESS:
      return {
        ...state,
        reportMisuseError: null,
        isReportingMisuse: false,
      };

    case REPORT_MISUSE_ERROR:
      return {
        ...state,
        reportMisuseError: payload.error,
        isReportingMisuse: false,
      };

    case GENERATE_OTP:
      return {
        ...state,
        generatingOtpError: null,
        loading: true,
      };

    case GENERATE_OTP_SUCCESS:
      return {
        ...state,
        generatingOtpError: null,
        loading: false,
      };

    case GENERATE_OTP_ERROR:
      return {
        ...state,
        loading: false,
        generatingOtpError: payload.error,
      };

    default:
      return state;
  }
};

export default reducer;

/* Side Effects
========================================================================== */

export const generateOTP = () => (dispatch, getState) => {
  const delayResend = () => {
    let timer = null;
    dispatch({ type: OTP_TIMER_START });
    clearInterval(timer);
    timer = setInterval(() => {
      dispatch({ type: OTP_TIMER_TICK });
      const { otpDelay } = getState().prepaidCard;
      if (otpDelay <= 0) {
        clearInterval(timer);
        dispatch({ type: OTP_TIMER_STOP });
      }
    }, 1000);
  };

  const { formData } = getState().prepaidCard;
  dispatch({ type: GENERATE_OTP });
  delayResend();
  prepaidCards
    .generateOTP(formData.email)
    .then(() => {
      dispatch({ type: GENERATE_OTP_SUCCESS });
    })
    .catch((err) => {
      if (process.env.NODE_ENV === 'development' && !window.Cypress) {
        console.error(err);
      }
      dispatch({
        type: GENERATE_OTP_ERROR,
        payload: { error: err.response.data },
      });
    });
};

export const fetchCardData = (id) => (dispatch, getState) => {
  const { isFetchingCardData } = getState().prepaidCard;

  if (isFetchingCardData) {
    return;
  }

  dispatch({ type: FETCH_CARD_DATA });

  prepaidCards
    .getById(id)
    .then((data) => {
      dispatch({ type: FETCH_CARD_DATA_SUCCESS, payload: { cardData: data } });
    })
    .catch((err) => {
      if (process.env.NODE_ENV === 'development' && !window.Cypress) {
        console.error(err);
      }
      dispatch({
        type: FETCH_CARD_DATA_ERROR,
        payload: { error: err.response.data },
      });
    });
};

export const fetchSensitiveCardData = () => (dispatch, getState) => {
  const { cardData, isFetchingSensitiveCardData } = getState().prepaidCard;

  if (isFetchingSensitiveCardData || !cardData.id) {
    return;
  }

  dispatch({ type: FETCH_SENSITIVE_CARD_DATA });

  prepaidCards
    .getSensitiveCardDetails(cardData.id)
    .then((data) => {
      dispatch({
        type: FETCH_SENSITIVE_CARD_DATA_SUCCESS,
        payload: { sensitiveCardData: data },
      });
    })
    .catch((err) => {
      if (process.env.NODE_ENV === 'development' && !window.Cypress) {
        console.error(err);
      }
      dispatch({
        type: FETCH_SENSITIVE_CARD_DATA_ERROR,
        payload: { error: err.response.data },
      });
    });
};

export const reportMisuse = (status) => (dispatch, getState) => {
  const { cardData, isReportingMisuse } = getState().prepaidCard;

  if (isReportingMisuse || !cardData.id) {
    return;
  }

  dispatch({ type: REPORT_MISUSE });

  prepaidCards
    .reportMisuse(cardData.id, status)
    .then(() => {
      dispatch({ type: REPORT_MISUSE_SUCCESS });

      fetchCardData(cardData.id)(dispatch, getState);
    })
    .catch((err) => {
      if (process.env.NODE_ENV === 'development' && !window.Cypress) {
        console.error(err);
      }
      dispatch({
        type: REPORT_MISUSE_ERROR,
        payload: { error: err.response.data },
      });
    });
};

/* Actions
========================================================================== */
export const submitForm = (formData) => (dispatch) =>
  dispatch({ type: SUBMIT_FORM, payload: { formData } });

/* Selectors
========================================================================== */
export const getIsLoading = (state) => state.prepaidCard.loading;
export const getFormData = (state) => state.prepaidCard.formData;
export const getGeneratingOtpError = (state) =>
  state.prepaidCard.generatingOtpError;
export const getCardData = (state) => state.prepaidCard.cardData;
export const getIsFetchingCardData = (state) =>
  state.prepaidCard.isFetchingCardData;
export const getFetchCardDataError = (state) =>
  state.prepaidCard.fetchCardDataError;
export const getSensitiveCardData = (state) =>
  state.prepaidCard.sensitiveCardData;
export const getIsFetchingSensitiveCardData = (state) =>
  state.prepaidCard.isFetchingSensitiveCardData;
export const getFetchSensitiveCardDataError = (state) =>
  state.prepaidCard.fetchSensitiveCardDataError;
export const getIsReportingMisuse = (state) =>
  state.prepaidCard.isReportingMisuse;
export const getReportMisuseError = (state) =>
  state.prepaidCard.reportMisuseError;
export const getAvailableBalanceStr = (state) => {
  const { currency = 'GBP', availableBalance } =
    state.prepaidCard.cardData || {};

  if (!availableBalance) {
    return (0).toLocaleString(undefined, { currency, style: 'currency' });
  }

  return (availableBalance / 100).toLocaleString(undefined, {
    currency,
    style: 'currency',
  });
};
export const getSpentAmountStr = (state) => {
  const {
    currency = 'GBP',
    availableBalance,
    issuedAmount,
    fundingStatus,
  } = state.prepaidCard.cardData || {};

  // An unfunded card's zero balance is missing funds, not spend: deriving
  // issuedAmount - availableBalance would fabricate "Amount used".
  const spentAmount =
    fundingStatus === 'pending' || fundingStatus === 'failed'
      ? 0
      : issuedAmount - availableBalance;

  if (!spentAmount) {
    return (0).toLocaleString(undefined, { currency, style: 'currency' });
  }

  return (spentAmount / 100).toLocaleString(undefined, {
    currency,
    style: 'currency',
  });
};
export const getOtpDelay = (state) => state.prepaidCard.otpDelay;
export const actions = {
  submitForm,
  generateOTP,
  fetchCardData,
  fetchSensitiveCardData,
  reportMisuse,
};
